module.exports = __webpack_public_path__ + "static/gallery-7-0ae0b9ada0c39f8b47b9caa1d93e73b3.jpg";